export default {
  title: 'Hotspots'
}

const Template = args => `
  <cradlepoint-container>
    <cradlepoint-hotspots
      background-image="${args['background-image']}"
    >
      ${args.slot}
    </cradlepoint-card-hotspots>
  </cradlepoint-container>
`;

export const Default = Template.bind({});

Default.args = {
  'background-image': 'https://cradlepoint.com/wp-content/uploads/2024/01/VEHICLES-5G-info-120623.gif',
  slot: `
    <cradlepoint-hotspot-item
      x="14.5"
      y="13"
      width="7.2",
      height="8"
    >
      <cradlepoint-card-simple-text class="text-charcoal bg-sunrise fit-content box-shadow-30 br-6">
        <h3>5G Solutions</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum, molestias?</p>
      </cradlepoint-card-simple-text>
    </cradlepoint-hotspot-item>
    <cradlepoint-hotspot-item
      x="27.7"
      y="16"
      width="20",
      height="11.5"
    >
      <cradlepoint-card-simple-text class="text-charcoal bg-sunrise fit-content box-shadow-30 br-6">
        <h3>Police</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere iure, a voluptatibus totam laudantium ratione consequuntur accusantium ea cumque cupiditate.</p>
        <cradlepoint-button-cta class="ml-0">Learn More</cradlepoint-button-cta>
      </cradlepoint-card-simple-text>
    </cradlepoint-hotspot-item>
    <cradlepoint-hotspot-item
      x="57.9"
      y="17.5"
      width="20.1",
      height="10"
      popup-anchor="top-right"
    >
      <cradlepoint-card-simple-text
        class="top-right bg-charcoal20 fit-content box-shadow-20 br-6"
      >
        <h3>Post</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere iure, a voluptatibus totam laudantium ratione consequuntur accusantium ea cumque cupiditate.</p>
        <cradlepoint-button-cta class="ml-0">
          Learn More
        </cradlepoint-button-cta>
      </cradlepoint-card-simple-text>
    </cradlepoint-hotspot-item>
    <cradlepoint-hotspot-item
      x="27.2"
      y="41.8"
      width="12.2",
      height="12.8"
      popup-width="500"
      popup-anchor="bottom-left"
    >
      <cradlepoint-card-simple-text
        class="bg-boise-blue fit-content box-shadow-30 br-6"
      >
        <h3 class="text-white">Public Transportation</h3>
        <p class="text-charcoal20">Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere iure, a voluptatibus totam laudantium ratione consequuntur accusantium ea cumque cupiditate.</p>
        <cradlepoint-button-cta
          class="ml-0"
          text-color="white"
          text-color-hover="var(--cwc-color-primary, #FFAD00)"
          background-color="var(--cwc-color-primary, #FFAD00)"
          background-color-hover="white"
          border-color="var(--cwc-color-primary, #FFAD00)"
        >
          Learn More
        </cradlepoint-button-cta>
      </cradlepoint-card-simple-text>
    </cradlepoint-hotspot-item>
  `
}
